import React, { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ConversationAssignment, ConversationReadState } from './ConversationActions';
import { usePatientConversationActions } from '../../hooks/usePatientConversationActions';
import { invalidateSidebarCounts } from '../../hooks/useSidebarCounts';
import type { ChatType } from '../../services/chat';

interface ConversationActionsBarProps {
    patientId: string;
    chatType: ChatType;
}

/**
 * Compact bar with team / assignee / read-state controls, shown above the chat
 * in the patient files Chat tab. Always visible so a reviewed conversation can
 * be flipped back to unread. Team and assignee address the thread's own viewer
 * row, so both threads get the full set of controls.
 */
const ConversationActionsBar: React.FC<ConversationActionsBarProps> = ({ patientId, chatType }) => {
    const queryClient = useQueryClient();
    const refreshSidebarCounts = useCallback(
        () => invalidateSidebarCounts(queryClient),
        [queryClient]
    );
    const actions = usePatientConversationActions(patientId, chatType, refreshSidebarCounts);

    return (
        <div className="flex items-center justify-between gap-3 px-4 py-2.5 border-b border-gray-200 bg-white flex-shrink-0">
            <ConversationAssignment actions={actions} variant="bar" />
            <ConversationReadState actions={actions} variant="bar" />
        </div>
    );
};

export default ConversationActionsBar;
